import React, { FC, useState } from 'react';

import { useAssignResultsState } from '../../../../../../../Common/AssignResults/Context/AssignResults.context';
import SkinsTableTiedExpandedRow from './Components/SkinsTableTiedExpandedRow';
import SkinsTableSingleRow from './Components/SkinsTableSingleRow';
import SkinsTableTiedCollapsedRow from './Components/SkinsTableTiedCollapsedRow';

export interface ISkinsTableRow {
  hole: string;
  index: number;
}

export const SkinsTableRow: FC<ISkinsTableRow> = props => {
  const { hole, index } = props;
  const { selectedCombination, skinsResults } = useAssignResultsState();
  const [collapsedRow, setCollapsedRow] = useState<null | number>(null);

  const onRowClick = (rowIndex: number) => () =>
    setCollapsedRow(collapsedRow === rowIndex ? null : rowIndex);

  return selectedCombination ? (
    skinsResults[Number(hole)].length === 1 ? (
      <SkinsTableSingleRow hole={hole} index={index} />
    ) : (
      <>
        <SkinsTableTiedCollapsedRow hole={hole} index={index} onRowClick={onRowClick} />

        <SkinsTableTiedExpandedRow hole={hole} index={index} collapsedRow={collapsedRow} />
      </>
    )
  ) : (
    <></>
  );
};
